import { RiExternalLinkLine } from "@remixicon/react";

interface ExternalResourceLinkProps {
  title: string;
  logoSrc: string;
  link: string;
  disabled?: boolean;
  note?: string;
}

export function ExternalResourceLink({ title, logoSrc, link, disabled, note }: ExternalResourceLinkProps) {
  if (disabled) {
    return (
      <div className="flex items-center p-4 rounded-lg border border-border bg-sidebar/50 opacity-70">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center mr-3 overflow-hidden">
          <div className="relative w-6 h-6 opacity-50">
            <img
              src={logoSrc}
              alt={title}
              width={24}
              height={24}
              className="object-contain"
            />
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium">{title}</h3>
            {note && <span className="text-xs text-muted-foreground">{note}</span>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="group"
    >
      <div className="flex items-center p-4 rounded-lg border border-border bg-sidebar hover:border-[#FF8A3C]/50 transition-all duration-300">
        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center mr-3 group-hover:bg-white transition-colors overflow-hidden">
          <div className="relative w-6 h-6">
            <img
              src={logoSrc}
              alt={title}
              width={24}
              height={24}
              className="object-contain"
            />
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium group-hover:text-[#FF8A3C] transition-colors">{title}</h3>
            <RiExternalLinkLine className="size-4 text-muted-foreground group-hover:text-[#FF8A3C] transition-colors" />
          </div>
        </div>
      </div>
    </a>
  );
}
